<template>
    <Modal id="settings-modal">
        <template v-slot:header>
            <div class="modl-header">
                <ModalTabs :tabs="tabs"
                           :selected-tab="selectedTab"
                           @select-tab="selectTab"></ModalTabs>
            </div>
        </template>

        <template v-slot:body>
            <component :is="selectedTab.component"
                       ref="current-tab-component"
                       @cancel="cancel"
                       @resolve="resolve" />
        </template>
    </Modal>
</template>

<script>
import CloverSettingsTab from '@/epos/vue/modals/Settings/CloverSettingsTab';
import DeviceSettingsTab from '@/epos/vue/modals/Settings/DeviceSettingsTab';
import DojoSettingsTab from '@/epos/vue/modals/Settings/DojoSettingsTab';
import KitchenSettingsTab from '@/epos/vue/modals/Settings/KitchenSettingsTab';
import MellonWebECRSettingsTab from '@/epos/vue/modals/Settings/MellonWebECRSettingsTab';
import Modal from '@/vue/components/Modals/Modal';
import ModalTabs from '@/vue/components/Modals/ModalTabs';
import PaymentMethodRef from '@/lib/PaymentMethods/PaymentMethodRef';
import PayyoSettingsTab from '@/epos/vue/modals/Settings/PayyoSettingsTab';
import PrintSettingsTab from '@/epos/vue/modals/Settings/PrintSettingsTab';
import VerifoneSettingsTab from '@/epos/vue/modals/Settings/VerifoneSettingsTab';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';
import { TabbedModalMixin } from '@/vue/mixins/TabbedModalMixin';

export default {
    name: 'SettingsModal',

    components: {
        CloverSettingsTab,
        DeviceSettingsTab,
        DojoSettingsTab,
        KitchenSettingsTab,
        MellonWebECRSettingsTab,
        Modal,
        ModalTabs,
        PayyoSettingsTab,
        PrintSettingsTab,
        VerifoneSettingsTab,
    },

    mixins: [
        ModalPropsMixin,
        TabbedModalMixin,
    ],

    data() {
        return {
            tabs: [
                {
                    name: 'device',
                    icon: 'fa-cash-register',
                    label: 'SETTINGS_MODAL.DEVICE_TAB_NAME',
                    component: 'DeviceSettingsTab',
                },
                {
                    name: 'print',
                    icon: 'fa-print',
                    label: 'SETTINGS_MODAL.PRINT_TAB_NAME',
                    component: 'PrintSettingsTab',
                },
            ],
        };
    },

    created() {
        // Add the Clover tab only if the device/company has Clover enabled.
        if (container.paymentMethodService.getByRef(PaymentMethodRef.CARD_CLOVER_CHIP_AND_PIN)) {
            this.tabs.push(
                {
                    name: 'clover',
                    icon: 'fa-credit-card',
                    label: 'SETTINGS_MODAL.CLOVER_TAB_NAME',
                    component: 'CloverSettingsTab',
                },
            );
        }

        // Add the Dojo tab only if the device/company has Dojo enabled.
        if (container.paymentMethodService.getByRef(PaymentMethodRef.CARD_DOJO_CHIP_AND_PIN)) {
            this.tabs.push(
                {
                    name: 'dojo',
                    icon: 'fa-credit-card',
                    label: 'SETTINGS_MODAL.DOJO_TAB_NAME',
                    component: 'DojoSettingsTab',
                },
            );
        }

        // Add the Mellon WebECR tab only if the device/company has Mellon WebECR enabled.
        if (container.paymentMethodService.getByRef(PaymentMethodRef.CARD_MELLON_WEBECR)) {
            this.tabs.push(
                {
                    name: 'mellon-webecr',
                    icon: 'fa-credit-card',
                    label: 'SETTINGS_MODAL.MELLON_WEBECR_TAB_NAME',
                    component: 'MellonWebECRSettingsTab',
                },
            );
        }

        // Add the Dojo tab only if the device/company has Dojo enabled.
        if (container.paymentMethodService.getByRef(PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN)) {
            this.tabs.push(
                {
                    name: 'payyo',
                    icon: 'fa-credit-card',
                    label: 'SETTINGS_MODAL.PAYYO_TAB_NAME',
                    component: 'PayyoSettingsTab',
                },
            );
        }

        // Add the Verifone tab only if the device/company has Verifone enabled.
        if (container.paymentMethodService.getByRef(PaymentMethodRef.CARD_VERIFONE_CHIP_AND_PIN)) {
            this.tabs.push(
                {
                    name: 'verifone',
                    icon: 'fa-credit-card',
                    label: 'SETTINGS_MODAL.VERIFONE_TAB_NAME',
                    component: 'VerifoneSettingsTab',
                },
            );
        }

        // Add the kitchen settings tab if the branch has kitchen enabled.
        if (container.userService.currentBranch.kitchenEnabled) {
            this.tabs.push(
                {
                    name: 'kitchen',
                    icon: 'fa-fork-knife',
                    label: 'SETTINGS_MODAL.KITCHEN_TAB_NAME',
                    component: 'KitchenSettingsTab',
                },
            );
        }
    },
};
</script>
